// eslint-disable-next-line import/prefer-default-export
export const samlConfig = {
  entity: 'https://app.anodot.com',
  postBindings: 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST',
  nameIdFormat: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  attrNameFormat: 'urn:oasis:names:tc:SAML:2.0:attrname-format:uri',
};
